module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-popover', {
    attrs: {
      "placement": "bottom-start",
      "open-delay": 300,
      "popper-class": "ushk-company-popover",
      "trigger": "click",
      "transition": "zoom-in-bottom",
      "popper-options": _vm.popperOptions,
      "is-remove-slot": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "ushk-company"
  }, [(_vm.datas.length) ? _vm._l((_vm.datas), function(data) {
    return (_vm.datas.length) ? _c('ushk-message', {
      key: data.id,
      attrs: {
        "data": data,
        "is-show-company-list": false
      }
    }) : _vm._e()
  }) : _c('div', {
    staticClass: "ushk-company_none"
  }, [_vm._v("暂无数杮")])], 2), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f66886","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/CompanyList.vue
// module id = pIJq
// module chunks = 1